/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespHeroCarouselRequestMoreImages_user$ref = any;
export type MeasurementUnit = "CM" | "IN" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespHeroCarousel_user$ref: FragmentReference;
export type PdpRespHeroCarousel_user = {|
  +profile: ?{|
    +measurementUnit: ?MeasurementUnit
  |},
  +$fragmentRefs: PdpRespHeroCarouselRequestMoreImages_user$ref,
  +$refType: PdpRespHeroCarousel_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespHeroCarousel_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarouselRequestMoreImages_user",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "measurementUnit",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '647ab6700b00677dc55731d80029f5c2';
module.exports = node;
